// extracted by mini-css-extract-plugin
export default {"desktop":"j0lG6","compact":"s89rf","mobile":"Spmbz"};